<script setup lang="ts">
import { ref } from 'vue'

import PrevStepBtn from '@/components/frontend/profile/common/PrevStepBtn.vue'

import { ProfileSteps } from '@/constant/user'

const prevStep = ref<ProfileSteps>(ProfileSteps.UPDATE_EMAIL_STEP_2)
</script>
<template>
  <div class="profile-edit-email-done">
    <PrevStepBtn :prev-step="prevStep" />
    <h3 class="profile-step-title">變更完成</h3>
    <p class="text-xs font-medium text-app-black-900">信箱已變更成功。</p>
  </div>
</template>
<style scoped></style>
